import React from "react";
import styled from "@emotion/styled";
import { Card as CardOrig } from "./Card";
import { CardLabel } from "./CardLabel";

const Card = styled(CardOrig)<{ variant: "primary" | "secondary" }>`
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing(3.25, 4, 3)};
  box-shadow: none;
  box-sizing: border-box;
  height: 192px;
  overflow: hidden;
  background-color: ${({ theme, variant }) =>
    variant === "primary"
      ? "rgba(232, 250, 255, 0.2)"
      : theme.palette.background.default};
  border-color: ${({ variant, theme }) =>
    variant === "primary"
      ? theme.palette.primary.light
      : theme.palette.border.secondary};
`;

interface Props {
  title: string;
  headline?: string;
  variant?: "primary" | "secondary";
  onClick?: () => void;
  caption?: React.ReactNode;
  icon?: React.ReactNode;
  children: React.ReactNode;
}

export const MiniCard = ({
  onClick,
  title,
  icon,
  variant = "secondary",
  headline,
  caption,
  children,
}: Props) => {
  return (
    <Card onClick={onClick} variant={variant}>
      <CardLabel
        icon={icon}
        title={title}
        headline={headline}
        caption={caption}
      />
      {children}
    </Card>
  );
};
